import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountRelationType  {
    _originalTypeClassName = "zERP.BO.AccountRelationType";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountRelationType.translate = translateService;
}
this.AccountRelationTypeID = null;
this.Name = null;
this._key = this.AccountRelationTypeID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountRelationTypeID:any;
get AccountRelationTypeID(): any {
    return this._AccountRelationTypeID;
  }
set AccountRelationTypeID(value: any) {
    this._AccountRelationTypeID = value;
    this._key = value;
  }
Name:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountRelationTypeID == null || $this.AccountRelationTypeID == 0;
            }


}